import {ICampaignType} from "../../../../model/campaign/ICampaignType";

export const initialCampaignType: ICampaignType = {
    title: '',
    description: '',
    descriptionGerman: '',
    followersRangeFrom: 0,
    followersRangeTo: 0,
    isActive: false
}